import React from 'react';
import { HighlightMatch } from 'components/lists/HighlightMatch';
import './TreeNodeName.less'


export interface ITreeNodeNameProps extends React.HTMLProps<{}> {
  name: string;
  searchString?: string;
}

 export function TreeNodeName({ name, searchString, children }: ITreeNodeNameProps) {
    return <div className="dp-common-tree-node-name" title={name}>
      <div className="dp-common-tree-node-name__text">
        <HighlightMatch searchString={searchString}>{name}</HighlightMatch>
      </div>
      {children}
    </div>
  }